import { localStorage } from '@muse-web/storages'

import { STORAGE_KEYS } from './storageKeys'

export const writeOldUsersPromoShownAtVisit = (visit: number): void => {
    if (typeof window === 'undefined') {
        return
    }

    localStorage.set(STORAGE_KEYS.oldUsersPromoShownAtVisit, visit)
}
